module.exports = __webpack_public_path__ + "static/img/64_hat.da72cb77.jpg";